import InstagramActionTypes from './instagram.types';

const INITIAL_STATE = {
	posts: null,
	isFetching: false,
	errorMessage: undefined,
};

const instagramReducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case InstagramActionTypes.FETCH_INSTAGRAM_POSTS_START:
			return {
				...state,
				isFetching: true,
			};
		case InstagramActionTypes.FETCH_INSTAGRAM_POSTS_SUCCESS:
			return {
				...state,
				isFetching: false,
				posts: action.payload,
			};
		case InstagramActionTypes.FETCH_INSTAGRAM_POSTS_FAILURE:
			return {
				...state,
				isFetching: false,
				errorMessage: action.payload,
			};
		default:
			return state;
	}
};

export default instagramReducer;
